import Vue from 'vue'
import vSelect from 'vue-select'

vSelect.props.clearable.default = false;

Vue.component('originalVSelect', vSelect);
export default Vue.component('originalVSelect').extend({
    props: {
        maxHeight: {
            type: String,
            default: function () {
                return this.calcDropdownHeight
            }
        },
    },
    computed: {
        calcDropdownHeight: function () {
            var viewportOffset = this.$el.getBoundingClientRect();
            // these are relative to the viewport, i.e. the window
            var top = viewportOffset.top;
            var bottom = viewportOffset.bottom;
            var height = viewportOffset.height
            var left = viewportOffset.left;
            var bottomMargin = 35;

            var distBottom = window.innerHeight - (top + height) - bottomMargin

            if(distBottom < 120){
                    distBottom = 120
            }

            return distBottom + 'px !important'
        }
    },
    methods: {
        maybeAdjustScroll: () => false
    }
});



// WEBPACK FOOTER //
// ./src/extends/vue-select.js